import Qs from 'qs';
import { buildAxiosClient } from '../../../common/models/axiosClient';
import type { AxiosPromise } from 'axios';
import { Company, QueryParams } from './company';

export class CompanyClient {
  searchCompanies(page: number, query: QueryParams): AxiosPromise<Company[]> {
    return buildAxiosClient().get('/api/v1/companies/search.json', {
      params: {
        page: page,
        q: query,
      },
      paramsSerializer: params =>
        Qs.stringify(params, { arrayFormat: 'brackets' }),
    });
  }
}
